import { useEffect, useRef } from "react";

// Live waveform. Spikes with mic input; flat line when there is no stream.
export function AudioWave({ stream, height = 72, testId }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const cctx = canvas.getContext("2d");
    const accent =
      getComputedStyle(document.documentElement).getPropertyValue("--accent").trim() || "#3BE577";
    const w = canvas.width;
    const h = canvas.height;
    let raf, audioCtx, analyser, source, data;

    const drawFlat = () => {
      cctx.clearRect(0, 0, w, h);
      cctx.strokeStyle = accent;
      cctx.globalAlpha = 0.35;
      cctx.lineWidth = 2;
      cctx.beginPath();
      cctx.moveTo(0, h / 2);
      cctx.lineTo(w, h / 2);
      cctx.stroke();
      cctx.globalAlpha = 1;
    };

    if (!stream) {
      drawFlat();
      return;
    }

    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    audioCtx = new AudioCtx();
    source = audioCtx.createMediaStreamSource(stream);
    analyser = audioCtx.createAnalyser();
    analyser.fftSize = 512;
    source.connect(analyser);
    data = new Uint8Array(analyser.frequencyBinCount);

    const draw = () => {
      raf = requestAnimationFrame(draw);
      analyser.getByteTimeDomainData(data);
      cctx.clearRect(0, 0, w, h);
      cctx.lineWidth = 2;
      cctx.strokeStyle = accent;
      cctx.beginPath();
      const slice = w / data.length;
      let x = 0;
      for (let i = 0; i < data.length; i++) {
        const v = data[i] / 128.0;
        const y = (v * h) / 2;
        if (i === 0) cctx.moveTo(x, y);
        else cctx.lineTo(x, y);
        x += slice;
      }
      cctx.lineTo(w, h / 2);
      cctx.stroke();
    };
    draw();

    return () => {
      if (raf) cancelAnimationFrame(raf);
      try { source.disconnect(); } catch (e) { /* ignore */ }
      try { audioCtx.close(); } catch (e) { /* ignore */ }
    };
  }, [stream]);

  return (
    <canvas
      ref={canvasRef}
      width={440}
      height={height}
      data-testid={testId}
      className="w-full"
      style={{ height, border: "1px solid var(--border)", background: "var(--bg-primary)" }}
    />
  );
}
